import { defineConfig } from '@chakra-ui/react'

export const customConfig = defineConfig({
  theme: {
    semanticTokens: {
      colors: {
        darkBlue: {
          value: '#1d4476',
        },
      },
    },
  },
})
